// src/features/monetize/useMonetizeEligibility.ts

import { useAuth } from '@/features/auth/hooks/useAuth';
import { FEATURE_FLAGS } from '@/lib/constants/featureFlags';
import { resolveMonetizeEligibility } from './eligibility';
import { useMonetizeStatus } from './useMonetizeStatus';

export interface MonetizeEligibility {
  eligible: boolean;
  /** True while the api's verdict is still loading (the nav waits; the page shows a skeleton). */
  isLoading: boolean;
}

/**
 * THE single seam for Monetize visibility — the nav entry, the /monetize page
 * and the help visibility consume this hook; nothing renders when it says no.
 * The verdict follows the account selector (the api answers per account).
 */
export function useMonetizeEligibility(): MonetizeEligibility {
  const { canViewMedia } = useAuth();
  const { status, isLoading } = useMonetizeStatus();
  return {
    eligible: resolveMonetizeEligibility({
      flagEnabled: FEATURE_FLAGS.monetizeEnabled,
      mediaAccess: canViewMedia,
      serverEnabled: status?.enabled,
    }),
    isLoading,
  };
}
